export const SystemButtonDefault = {
  onClick: () => {},
  disabled: false,
  iconLeft: '',
  iconRight: '',
  type: '',
};

export const SystemHyperlinkDefault = {
  onClick: () => {},
  target: '',
  href: undefined,
  rel: '',
  source: '',
};
